<script>
  import { layoutMethods, rouletteMethods, rouletteComputed, erpUserRolesMethods} from "@/state/helpers";
  // import Multiselect from "vue-multiselect";
  import InputColorPicker from 'vue-native-color-picker';
  import { required, requiredIf } from "vuelidate/lib/validators";
  import Swal from "sweetalert2";
  import moment from "moment";
  // Main JS (in UMD format)
  import VueTimepicker from 'vue2-timepicker/dist/VueTimepicker.umd.min.js'
  import { getModuleAccess } from '@/router/helper.js'

  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'

  export default {
    page: {
      title: "Roulette Main"
    },
    data() {
      return {
        itemId: this.$route.params.id,
        addModeOn: this.$route.params.id ? false : true,
        SundaydurationData: {
          HH: '00',
          mm: '00',
          ss: '00'
        },
        sundayCooldown: '',
        sundayWinners: 0,

        MondaydurationData: {
          HH: '00',
          mm: '00',
          ss: '00'
        },
        mondayCooldown: '',
        mondayWinners: 0,

        TuesdaydurationData: {
          HH: '00',
          mm: '00',
          ss: '00'
        },
        tuesdayCooldown: '',
        tuesdayWinners: 0,

        WednesdaydurationData: {
          HH: '00',
          mm: '00',
          ss: '00'
        },
        wednesdayCooldown: '',
        wednesdayWinners: 0,

        ThursdaydurationData: {
          HH: '00',
          mm: '00',
          ss: '00'
        },
        thursdayCooldown: '',
        thursdayWinners: 0,

        FridaydurationData: {
          HH: '00',
          mm: '00',
          ss: '00'
        },
        fridayCooldown: '',
        fridayWinners: 0,

        SaturdaydurationData: {
          HH: '00',
          mm: '00',
          ss: '00'
        },
        saturdayCooldown: '',
        saturdayWinners: 0,

        rouletteWinnersConfig: {},
        addNewWinnersConfigModeOn: true,

        title: "Roulette Main",
        mainId: 0,
        form : {
          mainId                    : 0,
          mainTitle                 : "",
          mainType                  : null,
          mainMessage               : "",
          mainAllowedDailySpin      : null,
          mainDisableOnlySundaySpin : 0,
          enabled                   : 0,
          isRequiredSpinCredActive  : 1,
          mainRequiredSpinCredit    : 0,
          alterColorMain1           : "#000000",
          alterColorMain2           : "#000000",
          mainPromoStartDateTime    : null,
          mainPromoEndDateTime      : null,
          mechanics                 : []
        },
        submitted: false,
        rouletteOptions:[
          {
            text: "WEEKLY WHEEL", 
            value: "WEEKLYWHEEL"
          },
          {
            text: "DAILY WHEEL", 
            value: "DAILYWHEEL"
          },
          {
            text: "ROLETA PROMO", 
            value: "SMARTROLETA"
          },
        ],
        rouletteMainModule: {
          access: {
            update: true
          }
        },
        rangeOptions: {
          minDate: "today",
          enableTime: true, 
          dateFormat: 'Y-m-d h:i K'
        },
      };
    },
    validations: {
      form : {
        mainTitle                : {required},
        mainMessage              : {required},
        // mainAllowedDailySpin     : {required},
        mainType                 : {required},
        mainPromoStartDateTime   : {required: requiredIf(function(form){return form.mainType == 'SMARTROLETA'})},
        mainPromoEndDateTime     : {required: requiredIf(function(form){return form.mainType == 'SMARTROLETA'})},

      }
    },
    components: {
      // Multiselect,
      "v-input-colorpicker": InputColorPicker,
      VueTimepicker,
      flatPickr,
    },
    
    methods: {
      ...layoutMethods,
      ...rouletteMethods,
      ...rouletteComputed,
      ...erpUserRolesMethods,
      async retrieveData(id){
        this.getRouletteMain(id).then((details) => {
          console.log("ROULETTE FETCHED DETAILS: ", details);
          details.mechanics = (details?.mechanics??null) == null ? this.form.mechanics : JSON.parse(details.mechanics)
          this.form  = details;
          console.log("FORM", this.form);

          this.listRouletteWinnersConfig({rouletteId: details.mainId}).then((data) => {
            this.rouletteWinnersConfig = data[0];
            this.addNewWinnersConfigModeOn = this.rouletteWinnersConfig ? false : true;
          }).catch(e => {
            console.log("error", e);
          });
        })
        .catch(e => {
            console.log("error", e);
        });    
      },
      checkForm() {
        this.submitted = true
        this.$v.$touch();
        if (!this.$v.form.$invalid){
          this.itemId=this.$route.params.id;
          if (this.itemId) {
            this.update();
            console.log("update Main Here");
          } else {
            console.log("create Main Here: ", this.form);
            this.createMain();
            // this.createItem();
          }
        }
      },
      getTimestampToReadable(timestamp)
      {
        // Constant
        const SECOND_IN_HOURS = 3600, SECOND_IN_MINUTES = 60;
        
        let timeStamp = timestamp,
            hours = 0,
            minutes = 0,
            seconds = 0;

        // hours
        while(timeStamp >= SECOND_IN_HOURS)
        {
          timeStamp -= SECOND_IN_HOURS;
          hours++;
        }
        // minutes
        while(timeStamp >= SECOND_IN_MINUTES)
        {
          timeStamp -= SECOND_IN_MINUTES;
          minutes++;
        }
        seconds = timeStamp;
        return {hours: hours > 9 ? "" + hours : "0" + hours, minutes: minutes > 9 ? "" + minutes : "0" + minutes, seconds: seconds > 9 ? "" + seconds : "0" + seconds};
      },

      convertHourlyFormatToTimeStamp(hours, minutes, seconds)
      {
        const SECOND_IN_HOURS = 3600, SECOND_IN_MINUTES = 60;
        let timestamp = 0;
        timestamp += parseInt(hours) > 0 ? parseInt(hours) * SECOND_IN_HOURS : 0;
        timestamp += parseInt(minutes) > 0 ? parseInt(minutes) * SECOND_IN_MINUTES : 0;
        timestamp += parseInt(seconds);
        return parseInt(timestamp);
      },
      saveConfigWinners() {
        console.log(this.convertHourlyFormatToTimeStamp(this.SundaydurationData.HH, this.SundaydurationData.mm, this.SundaydurationData.ss));

        let params = {
          rouletteId: this.mainId,
          sundayTimeStamp: parseInt(moment(this.sundayCooldown).format("X")),
          sundayWinners: this.sundayWinners,
          sundayDuration: this.convertHourlyFormatToTimeStamp(this.SundaydurationData.HH, this.SundaydurationData.mm, this.SundaydurationData.ss),
          mondayTimeStamp: parseInt(moment(this.mondayCooldown).format("X")),
          mondayWinners: this.mondayWinners,
          mondayDuration: this.convertHourlyFormatToTimeStamp(this.MondaydurationData.HH, this.MondaydurationData.mm, this.MondaydurationData.ss),
          tuesdayTimeStamp: parseInt(moment(this.tuesdayCooldown).format("X")),
          tuesdayWinners: this.tuesdayWinners,
          tuesdayDuration: this.convertHourlyFormatToTimeStamp(this.TuesdaydurationData.HH, this.TuesdaydurationData.mm, this.TuesdaydurationData.ss),
          wednesdayTimeStamp: parseInt(moment(this.wednesdayCooldown).format("X")),
          wednesdayWinners: this.wednesdayWinners,
          wednesdayDuration: this.convertHourlyFormatToTimeStamp(this.WednesdaydurationData.HH, this.WednesdaydurationData.mm, this.WednesdaydurationData.ss),
          thursdayTimeStamp: parseInt(moment(this.thursdayCooldown).format("X")),
          thursdayWinners: this.thursdayWinners,
          thursdayDuration: this.convertHourlyFormatToTimeStamp(this.ThursdaydurationData.HH, this.ThursdaydurationData.mm, this.ThursdaydurationData.ss),
          fridayTimeStamp: parseInt(moment(this.fridayCooldown).format("X")),
          fridayWinners: this.fridayWinners,
          fridayDuration: this.convertHourlyFormatToTimeStamp(this.FridaydurationData.HH, this.FridaydurationData.mm, this.FridaydurationData.ss),
          saturdayTimeStamp: parseInt(moment(this.saturdayCooldown).format("X")),
          saturdayWinners: this.saturdayWinners,
          saturdayDuration: this.convertHourlyFormatToTimeStamp(this.SaturdaydurationData.HH, this.SaturdaydurationData.mm, this.SaturdaydurationData.ss),
        }

        if (this.addNewWinnersConfigModeOn) { // call the API for CREATE Winner Config
          this.createRouletteWinnersConfig(params).then(async (response)=> {
            if(response.status == 'ok') {
              Swal.fire("Update Successful!", response.message, "success");
              await this.retrieveData(this.mainId);
            }
            else {
              Swal.fire("", response.message ,"error");
            }
            
          }).catch((err) => {
            if(err.status == 'err') {
              Swal.fire("", err.message ,"error");
            }
          });
        }
        else { // call the API for UPDATE Winner Config
          this.updateRouletteWinnersConfig(params).then(async (response)=> {
            if(response.status == 'ok')
            {
              Swal.fire("", response.message.search("1") == -1 ? response.message.replace("data 2 id", "Grand Weekly Roleta") : response.message.replace("data 1 id", "Daily Roleta") ,"success");
              await this.retrieveData(this.mainId);
              //this.reloadConfigWinners();

            }
            else {
              Swal.fire("", response.message ,"error");
            }
            
          }).catch((err) => {
            if(err.status == 'err')
            {
              Swal.fire("", err.message ,"error");
            }
          });
        }
      },
      onResetCooldown(weekday) {
        switch(weekday)
        {
            case 'sunday':
              this.sundayCooldown = moment.unix(moment().unix()).format('MMMM DD, YYYY hh:mm:ss a');
              break;
            case 'monday':
              this.mondayCooldown = moment.unix(moment().unix()).format('MMMM DD, YYYY hh:mm:ss a');
              break;
            case 'tuesday':
              this.tuesdayCooldown = moment.unix(moment().unix()).format('MMMM DD, YYYY hh:mm:ss a');
              break;
            case 'wednesday':
              this.wednesdayCooldown = moment.unix(moment().unix()).format('MMMM DD, YYYY hh:mm:ss a');
              break;
            case 'thursday':
              this.thursdayCooldown = moment.unix(moment().unix()).format('MMMM DD, YYYY hh:mm:ss a');
              break;
            case 'friday':
              this.fridayCooldown = moment.unix(moment().unix()).format('MMMM DD, YYYY hh:mm:ss a');
              break;
            case 'saturday':
              this.saturdayCooldown = moment.unix(moment().unix()).format('MMMM DD, YYYY hh:mm:ss a');
              break;
        }
      },
      reloadConfigWinners()
      {
        let dateTimeNow = moment.unix(moment().unix()).format('MMMM DD, YYYY hh:mm:ss a');

        if (!this.isEmpty(this.rouletteWinnersConfig)) {
          // Sunday
          this.SundaydurationData = {
            HH: this.getTimestampToReadable(this.rouletteWinnersConfig.sundayDuration).hours,
            mm: this.getTimestampToReadable(this.rouletteWinnersConfig.sundayDuration).minutes,
            ss: this.getTimestampToReadable(this.rouletteWinnersConfig.sundayDuration).seconds
          }
          this.sundayWinners = this.rouletteWinnersConfig.sundayWinners;
          this.sundayCooldown = moment.unix(this.rouletteWinnersConfig.sundayTimeStamp).format('MMMM DD, YYYY hh:mm:ss a');
        
          // Monday
          this.MondaydurationData = {
            HH: this.getTimestampToReadable(this.rouletteWinnersConfig.mondayDuration).hours,
            mm: this.getTimestampToReadable(this.rouletteWinnersConfig.mondayDuration).minutes,
            ss: this.getTimestampToReadable(this.rouletteWinnersConfig.mondayDuration).seconds
          }
          this.mondayWinners = this.rouletteWinnersConfig.mondayWinners;
          this.mondayCooldown = moment.unix(this.rouletteWinnersConfig.mondayTimeStamp).format('MMMM DD, YYYY hh:mm:ss a');
        
          // Tuesday
          this.TuesdaydurationData = {
            HH: this.getTimestampToReadable(this.rouletteWinnersConfig.tuesdayDuration).hours,
            mm: this.getTimestampToReadable(this.rouletteWinnersConfig.tuesdayDuration).minutes,
            ss: this.getTimestampToReadable(this.rouletteWinnersConfig.tuesdayDuration).seconds
          }
          this.tuesdayWinners = this.rouletteWinnersConfig.tuesdayWinners;
          this.tuesdayCooldown = moment.unix(this.rouletteWinnersConfig.tuesdayTimestamp).format('MMMM DD, YYYY hh:mm:ss a');
            
          // Wednesday
          this.WednesdaydurationData = {
            HH: this.getTimestampToReadable(this.rouletteWinnersConfig.wednesdayDuration).hours,
            mm: this.getTimestampToReadable(this.rouletteWinnersConfig.wednesdayDuration).minutes,
            ss: this.getTimestampToReadable(this.rouletteWinnersConfig.wednesdayDuration).seconds
          }
          this.wednesdayWinners = this.rouletteWinnersConfig.wednesdayWinners;
          this.wednesdayCooldown = moment.unix(this.rouletteWinnersConfig.wednesdayTimeStamp).format('MMMM DD, YYYY hh:mm:ss a');
          
          // Thursday
          this.ThursdaydurationData = {
            HH: this.getTimestampToReadable(this.rouletteWinnersConfig.thursdayDuration).hours,
            mm: this.getTimestampToReadable(this.rouletteWinnersConfig.thursdayDuration).minutes,
            ss: this.getTimestampToReadable(this.rouletteWinnersConfig.thursdayDuration).seconds
          }
          this.thursdayWinners = this.rouletteWinnersConfig.thursdayWinners;
          this.thursdayCooldown = moment.unix(this.rouletteWinnersConfig.thursdayTimestamp).format('MMMM DD, YYYY hh:mm:ss a');

          // Friday
          this.FridaydurationData = {
            HH: this.getTimestampToReadable(this.rouletteWinnersConfig.fridayDuration).hours,
            mm: this.getTimestampToReadable(this.rouletteWinnersConfig.fridayDuration).minutes,
            ss: this.getTimestampToReadable(this.rouletteWinnersConfig.fridayDuration).seconds
          }
          this.fridayWinners = this.rouletteWinnersConfig.fridayWinners;
          this.fridayCooldown = moment.unix(this.rouletteWinnersConfig.fridayTimestamp).format('MMMM DD, YYYY hh:mm:ss a');
          
          // Saturday
          this.SaturdaydurationData = {
            HH: this.getTimestampToReadable(this.rouletteWinnersConfig.saturdayDuration).hours,
            mm: this.getTimestampToReadable(this.rouletteWinnersConfig.saturdayDuration).minutes,
            ss: this.getTimestampToReadable(this.rouletteWinnersConfig.saturdayDuration).seconds
          }
          this.saturdayWinners = this.rouletteWinnersConfig.saturdayWinners;
          this.saturdayCooldown = moment.unix(this.rouletteWinnersConfig.saturdayTimestamp).format('MMMM DD, YYYY hh:mm:ss a');
        }
        else {
          this.sundayCooldown = this.sundayCooldown ? this.sundayCooldown : dateTimeNow
          this.mondayCooldown = this.mondayCooldown ? this.mondayCooldown : dateTimeNow
          this.tuesdayCooldown = this.tuesdayCooldown ? this.tuesdayCooldown : dateTimeNow
          this.wednesdayCooldown = this.wednesdayCooldown ? this.wednesdayCooldown : dateTimeNow
          this.thursdayCooldown = this.thursdayCooldown ? this.thursdayCooldown : dateTimeNow
          this.fridayCooldown = this.fridayCooldown ? this.fridayCooldown : dateTimeNow
          this.saturdayCooldown = this.saturdayCooldown ? this.saturdayCooldown : dateTimeNow
        }
        
      },
      showConfigWinners()
      {        
        
        this.reloadConfigWinners();
        this.$bvModal.show("bv-modal-configwinners-view");
      },
      async createMain(){
        // Assemble the payload
        let element1 = document.getElementById("main-promo-start-datetime");
        let tempStartDate = element1.value;

        let element2 = document.getElementById("main-promo-end-datetime");
        let tempEndDate = element2.value;

        let requestPayload = {
          mainTitle: this.form.mainTitle,
          mainType: this.form.mainType,
          mainMessage: this.form.mainMessage,
          mainAllowedDailySpin: this.form.mainAllowedDailySpin ? this.form.mainAllowedDailySpin : 0,
          mainDisableOnlySundaySpin: this.form.mainDisableOnlySundaySpin,
          enabled: this.form.enabled,
          isRequiredSpinCredActive: this.form.isRequiredSpinCredActive,
          mainRequiredSpinCredit: this.form.mainRequiredSpinCredit,
          alterColorMain1: this.form.alterColorMain1,
          alterColorMain2: this.form.alterColorMain2,
          mainPromoStartDateTime: this.isEmpty(tempStartDate) ? null : moment(tempStartDate).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
          mainPromoEndDateTime: this.isEmpty(tempEndDate) ? null : moment(tempEndDate).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
          mechanics: this.form.mechanics
        }

        console.log("CALL API FOR CREATE MAIN ROULETTE: ", requestPayload);
        this.createRouletteMain(requestPayload)
          .then((res) => {
              console.log(":::: DONE CREATING MAIN :::: ", res);
              let responseData = res;

              if (responseData.status == "warning") {
                Swal.fire({
                  title: "Duplicated Record",
                  html: `${responseData.message}`,
                  icon: "warning",
                  showCancelButton: false,
                  // confirmButtonColor: "#fff",
                  confirmButtonText: "OK",
                  customClass: {
                    confirmButton: 'btn-confirm',
                  }
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.isSubmitted = false
                  }
                });
              }
              else {
                Swal.fire("Update Successful!", `Main ${this.form.mainTitle} Roulette has been created.`,"success");
                
                // Redirect back to the Roulette Main List
                this.$router.push(
                  this.$route.query.redirectFrom || {
                    name: "Roulette Main",
                  }
                );
              }

          })
          .catch((error) => {
            console.log("Error in creating Main Roulette: ", error);
          });
      },
      checkChangedValue(data) {
        switch (data) {
          case "mainType": {
            this.form.mainPromoStartDateTime = null;
            this.form.mainPromoEndDateTime = null;
            break;
          }
        
          default:
            break;
        }
      },
      update(){
        // Assemble the payload
        let element1 = document.getElementById("main-promo-start-datetime");
        let tempStartDate = element1.value;

        let element2 = document.getElementById("main-promo-end-datetime");
        let tempEndDate = element2.value;

        let requestPayload = {
          mainId: this.form.mainId,
          mainTitle: this.form.mainTitle,
          mainType: this.form.mainType,
          mainMessage: this.form.mainMessage,
          mainAllowedDailySpin: this.form.mainAllowedDailySpin ? this.form.mainAllowedDailySpin : 0,
          mainDisableOnlySundaySpin: this.form.mainDisableOnlySundaySpin,
          enabled: this.form.enabled,
          isRequiredSpinCredActive: this.form.isRequiredSpinCredActive,
          mainRequiredSpinCredit: this.form.mainRequiredSpinCredit,
          alterColorMain1: this.form.alterColorMain1,
          alterColorMain2: this.form.alterColorMain2,
          mainPromoStartDateTime: this.isEmpty(tempStartDate) ? null : moment(tempStartDate).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
          mainPromoEndDateTime: this.isEmpty(tempEndDate) ? null : moment(tempEndDate).tz('UTC').format("YYYY-MM-DD HH:mm:ss"),
          mechanics: this.form.mechanics
        }

        console.log("CALL API FOR UPDATE MAIN ROULETTE: ", requestPayload);
        this.updateRouletteMain(requestPayload)
          .then(() => {
            this.createModal = false;
            Swal.fire("Update Successful!", `Main ${this.form.mainTitle} Roulette has been updated.`,"success");
            this.$router.push(
              this.$route.query.redirectFrom || {
                name: "Roulette Main",
              }
            );
            
          })
          .catch((e) => {
            this.createModal = false;
            Swal.fire("Update Failed!", `Main ${this.form.mainTitle} Roulette was not updated. Reason: ${e}`,"warning");
            console.log("Error in updating Main Roulette: ", e);
          });
      },
      isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
      },
      addMechanics (){
        // console.log('Before push:', this.form.mechanics);  // Log to ensure inputs is an array
        // this.form.mechanics = []
        if (Array.isArray(this.form.mechanics)) {
          this.form.mechanics.push({"q":null,"a":null});
        } else {
          console.error('inputs is not an array');
        }
      },
      removeInput (index){
        Swal.fire(
          {
            title: "Remove Mechanics",
            html: `
              <p>Are you sure you want to remove these mechanics?</p>
              <p><b>Question:</b> ${this.form.mechanics[index]?.q}</p>
              <p><b>Answer:</b> ${this.form.mechanics[index]?.a}</p>
              `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No"
          }
        ).then((result) => {
            if (result.isConfirmed) {
              this.form.mechanics.splice(index, 1);
            }
        });
      }
    },
    computed: {
      // rouletteWheelType: {
      //   get(){
      //     var _rouletteType = null;
      //     this.rouletteOptions.forEach(b => {
      //       if(b.value == this.form.mainType)
              
      //         _rouletteType = b;

      //      });
          
      //     return _rouletteType;
      //   },
      //   set(_rouletteType)
      //   {
      //     if(_rouletteType){
      //       this.form.mainRype = _rouletteType.value;
      //     } else {
      //       this.form.mainRype = null;
      //     }
      //   }
      // },
    },
    watch: {
      'form.enabled': function (newVal) {
          this.form.enabled = newVal | 0;
      },
      'form.mainDisableOnlySundaySpin': function (newVal) {
          this.form.mainDisableOnlySundaySpin = newVal | 0;
      },
      'form.isRequiredSpinCredActive': function (newVal) {
          this.form.isRequiredSpinCredActive = newVal | 0;
      },
    },
    async mounted(){
      this.changeTitle({title: 'Roulette Main'});
      this.mainId = this.$route.params.id;
      if (this.mainId > 0) {
        await this.retrieveData(this.mainId);
      }
      this.changeTitle({
        title: (this.mainId > 0 ? "Update" : "Add") + " Roulette Main Prize",
      });
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Roulette Main', to: { name: 'Roulette Main'} },
          { text: 'Roleta Type', to: { name: 'Roulette Main'} },
        ]
      });

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'Roulette', 'Roulette Main')
        .then((access) => this.rouletteMainModule.access = access);
        
    }
  }
    
</script>

<template>
  <div>
      <ValidationObserver v-slot="{ handleSubmit, reset }">
        <b-form @submit.prevent="handleSubmit(checkForm)" @@reset.prevent="reset">
            <div class="px-lg-2">
              <div class="card col-12 col-sm-8 col-md-7">
                <div class="card-body" >
                  <div class="row">
                    <label v-if="mainId > 0 && !rouletteMainModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a Roulette.</label>
                    <div class="col-md-12 mb-3">
                      <label class="form-label"
                        >Title<span style="color: red"> *</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="title"
                        v-model="form.mainTitle"
                        placeholder="Enter title"
                        :class="{
                              'is-invalid': submitted && $v.form.mainTitle.$error,
                          }"
                      />
                    </div>
                   
                    <div class="col-md-12 mb-3">
                      <label class="form-label"
                        >Description<span style="color: red"> *</span></label
                      >
                      <b-form-textarea
                          id="textarea"
                          v-model="form.mainMessage"
                          placeholder="Enter roleta description"
                          rows="3"
                          max-rows="6"
                          :class="{
                            'is-invalid': submitted && $v.form.mainMessage.$error,
                          }"
                        ></b-form-textarea>
                    </div>

                    <div class="col-md-6 mb-3">
                        <label class="form-label">Roulette Type<span style="color: red"> *</span></label >
                        <!-- <multiselect
                        v-model="rouletteWheelType"
                        :options="rouletteOptions"
                        track-by="value"
                        label="text"
                        name="rouletteType"
                        select-label="Click to select"
                        deselect-label="Click to remove"
                        placeholder="Select Roulette Type"
                        :allow-empty="true"
                        :preselect-first="false"
                        ></multiselect> -->
                        <template>
                          <b-form-select v-model="form.mainType" 
                                         :options="rouletteOptions" 
                                         class="form-select shadow-none"
                                         :class="{
                                              'is-invalid' : submitted && $v.form.mainType.$error
                                         }"
                                         @change="checkChangedValue('mainType')">
                            <template #first>
                              <b-form-select-option :value="null" 
                                                    disabled>
                                Select Roulette Type
                              </b-form-select-option>
                            </template>
                          </b-form-select>
                        </template>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label
                          class="form-check-label mb-2"
                          for="rewin"
                          >Daily Spin
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          id="title"
                          v-model="form.mainAllowedDailySpin"
                          placeholder="Enter Daily Spin"
                          />
                    </div>
                    
                    <div class="col-md-6 mb-3">
                      <div class="row">
                        <div class="col-6 mb-3">
                          <label class="form-label"
                            >Alter Color 1<span style="color: red"> *</span></label
                          >
                          <br/>
                          <v-input-colorpicker  
                            v-model="form.alterColorMain1" 
                          />
                        </div>
                        <div class="col-6 mb-3">
                          <label class="form-label"
                            >Alter Color 2<span style="color: red"> *</span></label
                          >
                          <br/>
                          <v-input-colorpicker  
                            v-model="form.alterColorMain2" 
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-3">
                      <div class="d-flex justify-content-between">
                        <div>
                          <label class="form-label">
                            Required Spin Credit
                          </label>
                        </div>
                        <div class="form-check form-switch">
                          <input
                            class="form-check-input"
                            v-model="form.isRequiredSpinCredActive"
                            type="checkbox"
                            id="requiredSpinCredit"
                          />
                          <label
                            class="form-check-label"
                            for="requiredSpinCredit"
                            >{{ form.isRequiredSpinCredActive ? "Active" : "Inactive" }}</label
                          >
                        </div>
                      </div>
                      <div class="col-md-12 mb-3">
                        <input type="number"
                                class="form-control"
                                v-model="form.mainRequiredSpinCredit"
                                placeholder="Enter Spin Credit" />
                      </div>
                    </div>
                 
                    <div class="col-md-12 mb-3">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          v-model="form.mainDisableOnlySundaySpin"
                          type="checkbox"
                          id="rewin"
                        />
                        <label
                          class="form-check-label"
                          for="rewin"
                          >Only Sunday Spin</label
                        >
                      </div>
                    </div>

                    <div class="col-md-12 mb-4">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          v-model="form.enabled"
                          type="checkbox"
                          id="ramdomizer"
                        />
                        <label
                          class="form-check-label"
                          for="ramdomizer"
                          >Status : <span :style="[ form.enabled == 0 ? {color: 'red'} : {color: 'green'} ]">{{ form.enabled == 0 ? 'Deactivated' : 'Activated'}}</span></label
                        >
                      </div>
                    </div>

                    <div class="card-header py-0 mb-3"></div> <!-- Divider -->

                    <p class="font-size-15 fw-medium mb-3">Roleta Promo Period</p>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label class="form-label"
                               :style="[ form.mainType != 'SMARTROLETA' ? {color: 'gray'} : {} ]">
                          Promo Start Date & Time 
                          <span class="text-danger" v-if="form.mainType == 'SMARTROLETA'">*</span>
                        </label>
                        <b-input-group>
                          <b-input-group-append class="rounded-start input-append"
                                                :class="{
                                                    'append-red-border' : submitted && form.mainType == 'SMARTROLETA' && $v.form.mainPromoStartDateTime.$error
                                                }">
                            <i class="bx bx-calendar"></i>
                          </b-input-group-append>

                          <flat-pickr placeholder="Select a date"
                                      v-model="form.mainPromoStartDateTime"
                                      :config="rangeOptions"
                                      class="form-control"
                                      :class="{
                                          'is-invalid' : submitted && form.mainType == 'SMARTROLETA' && $v.form.mainPromoStartDateTime.$error
                                      }"
                                      id="main-promo-start-datetime"
                                      :disabled="form.mainType != 'SMARTROLETA'"
                                      required
                                      style="border-left: none; padding-left: .5rem;"
                          ></flat-pickr>
                        </b-input-group>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label" 
                               :style="[ form.mainType != 'SMARTROLETA' ? {color: 'gray'} : {} ]">
                          Promo End Date & Time 
                          <span class="text-danger" v-if="form.mainType == 'SMARTROLETA'">*</span>
                        </label>
                        <b-input-group>
                          <b-input-group-append class="rounded-start input-append"
                                                :class="{
                                                    'append-red-border' : submitted && form.mainType == 'SMARTROLETA' && $v.form.mainPromoEndDateTime.$error
                                                }">
                            <i class="bx bx-calendar"></i>
                          </b-input-group-append>

                          <flat-pickr placeholder="Select a date"
                                      v-model="form.mainPromoEndDateTime"
                                      :config="rangeOptions"
                                      class="form-control"
                                      :class="{
                                          'is-invalid' : submitted && form.mainType == 'SMARTROLETA' && $v.form.mainPromoEndDateTime.$error
                                      }"
                                      id="main-promo-end-datetime"
                                      :disabled="form.mainType != 'SMARTROLETA'"
                                      required
                                      style="border-left: none; padding-left: .5rem;"
                          ></flat-pickr>
                        </b-input-group>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <p class="font-size-15 fw-medium mb-3">Roleta Mechanics</p>
                      </div>
                      <p v-if="form.mechanics.length == 0">No Mechanics Added</p>
                      <!-- {{ JSON.stringify(form.mechanics) }} -->
                      <!-- Loop through the array and render input fields -->
                      <div v-for="(mechanics, index) in form.mechanics" :key="index">
                        <div class="col-12 d-flex mb-2">
                          <div class="w-50 me-2">
                            <label>Enter Question #{{ index+1 }}:</label>
                            <b-form-textarea
                              v-model="form.mechanics[index].q"
                              placeholder="Enter Question"
                              rows="2"
                              max-rows="3"
                            ></b-form-textarea>
                          </div>
                          <div class="w-50 me-2">
                            <label>Enter Answer #{{ index+1 }}:</label>
                            <b-form-textarea
                              v-model="form.mechanics[index].a"
                              placeholder="Enter Answer"
                              rows="2"
                              max-rows="3"
                              class="w-90"
                            ></b-form-textarea>
                          </div>
                          <button @click="removeInput(index)" class="btn btn-light w-10" type="button"><i class="bx bx-trash bx-xs bx-fw"></i></button>
                        </div>
                      </div>
                      <div class="col-12 mb-4">
                          <!-- Button to add more input fields -->
                          <button @click="addMechanics()" class="btn btn-primary" type="button">Add Mechanics</button>

                      </div>
                    </div>

                    <div class="col-md-12 mb-3">
                      <b-btn :disabled="!rouletteMainModule.access.update || addModeOn" 
                             class="w-15 mt-3" 
                             type="button" 
                             variant="primary" 
                             @click="showConfigWinners">
                        Configure Winners Data
                      </b-btn>
                    </div>

                    <div class="justify-content-lg-end mb-lg-3">
                       <b-row class="col-md-12 mb-3">
                        <b-col
                          ><b-btn :disabled="!rouletteMainModule.access.update" class="w-100" type="submit" variant="primary"
                            >Save</b-btn
                          ></b-col
                        >
                        <b-col>
                          <router-link :to="{ name: 'Roulette Main', params: {} }" class="tc-white">
                              <b-button
                                variant="light"
                                class="w-sm w-100p"
                                type="button"
                                >Cancel</b-button
                              >
                          </router-link>
                          <!-- <b-btn class="w-100 btn btn-light" >
                            
                          </b-btn> -->
                        </b-col>
                      </b-row> 
                    </div>
                  </div>
                </div>
             </div>
            </div> 
        </b-form>

        <!-- show info modal -->
        <b-modal 
          id="bv-modal-configwinners-view" 
          centered 
          size="xl" 
          title="Viewing Winners Data Configurations" 
          hide-footer 
          no-close-on-backdrop
        >
          <div class="pb-4">
            <div class="row">
              <div class="col-6">
                <p class="h3 fw-bold">{{form.mainTitle}} Winners Configuration</p>
              </div>
              <div class="col-2">
                <b-btn class="" type="button" variant="primary" @click="saveConfigWinners">Save Configurations</b-btn>
              </div>
              <div class="row mt-3 config-table">
                <p class="h4 mx-4 fw-bold">Sunday</p>
                <div class="d-flex">
                  <div class="col-3">
                    <p class="mx-4 ml-5 fw-bold">Next Winner On</p>
                    <input type="text" class="form-control mx-4" id="sunday-cooldown-input" v-model="sundayCooldown" disabled />
                  </div>
                  <div class="col-2 mx-4">
                    <p class="mx-4 fw-bold">Winner(s) Limit</p>
                    <input type="text" class="form-control mx-4" id="sunday-winners-input" placeholder="" v-model="sundayWinners" />
                  </div>
                  <div class="col-3">
                    <p class="mx-5 fw-bold">Duration</p>
                    <vue-timepicker class="mx-5 mt-1  fw-bold" v-model="SundaydurationData" format="HH:mm:ss"></vue-timepicker>
                  </div>
                  <div class="col-2">
                    <b-btn class="mt-4 mr-3" type="button" variant="primary" @click="onResetCooldown('sunday')">Reset Cooldown</b-btn>
                  </div>
                </div>
              </div>
              <!-- Only Daily Wheels -->
              <div v-if="form.mainType == 'DAILYWHEEL' || form.mainDisableOnlySundaySpin != 1">
                <div class="row mt-3">
                  <p class="h4 mx-4 fw-bold">Monday</p>
                  <div class="d-flex">
                    <div class="col-3">
                      <p class="mx-4 ml-5 fw-bold">Next Winner On</p>
                      <input type="text" class="form-control mx-4" id="sunday-cooldown-input" v-model="mondayCooldown" disabled />
                    </div>
                    <div class="col-2 mx-4">
                      <p class="mx-4 fw-bold">Winner(s) Limit</p>
                      <input type="text" class="form-control mx-4" id="sunday-winners-input" placeholder="" v-model="mondayWinners" />
                    </div>
                    <div class="col-3">
                      <p class="mx-5 fw-bold">Duration</p>
                      <vue-timepicker class="mx-5 mt-1  fw-bold" v-model="MondaydurationData" format="HH:mm:ss"></vue-timepicker>
                    </div>
                    <div class="col-2">
                      <b-btn class="mt-4 mr-3" type="button" variant="primary" @click="onResetCooldown('monday')">Reset Cooldown</b-btn>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <p class="h4 mx-4 fw-bold">Tuesday</p>
                  <div class="d-flex">
                    <div class="col-3">
                      <p class="mx-4 ml-5 fw-bold">Next Winner On</p>
                      <input type="text" class="form-control mx-4" id="monday-cooldown-input" v-model="tuesdayCooldown" disabled />
                    </div>
                    <div class="col-2 mx-4">
                      <p class="mx-4 fw-bold">Winner(s) Limit</p>
                      <input type="text" class="form-control mx-4" id="monday-winners-input" placeholder="" v-model="tuesdayWinners" />
                    </div>
                    <div class="col-3">
                      <p class="mx-5 fw-bold">Duration</p>
                      <vue-timepicker class="mx-5 mt-1  fw-bold" v-model="TuesdaydurationData" format="HH:mm:ss"></vue-timepicker>
                    </div>
                    <div class="col-2">
                      <b-btn class="mt-4 mr-3" type="button" variant="primary" @click="onResetCooldown('tuesday')">Reset Cooldown</b-btn>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <p class="h4 mx-4 fw-bold">Wednesday</p>
                  <div class="d-flex">
                    <div class="col-3">
                      <p class="mx-4 ml-5 fw-bold">Next Winner On</p>
                      <input type="text" class="form-control mx-4" id="wednesday-cooldown-input" v-model="wednesdayCooldown" disabled />
                    </div>
                    <div class="col-2 mx-4">
                      <p class="mx-4 fw-bold">Winner(s) Limit</p>
                      <input type="text" class="form-control mx-4" id="wednesday-winners-input" placeholder="" v-model="wednesdayWinners" />
                    </div>
                    <div class="col-3">
                      <p class="mx-5 fw-bold">Duration</p>
                      <vue-timepicker class="mx-5 mt-1  fw-bold" v-model="WednesdaydurationData" format="HH:mm:ss"></vue-timepicker>
                    </div>
                    <div class="col-2">
                      <b-btn class="mt-4 mr-3" type="button" variant="primary" @click="onResetCooldown('wednesday')">Reset Cooldown</b-btn>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <p class="h4 mx-4 fw-bold">Thursday</p>
                  <div class="d-flex">
                    <div class="col-3">
                      <p class="mx-4 ml-5 fw-bold">Next Winner On</p>
                      <input type="text" class="form-control mx-4" id="thursday-cooldown-input" v-model="thursdayCooldown" disabled />
                    </div>
                    <div class="col-2 mx-4">
                      <p class="mx-4 fw-bold">Winner(s) Limit</p>
                      <input type="text" class="form-control mx-4" id="thursday-winners-input" placeholder="" v-model="thursdayWinners" />
                    </div>
                    <div class="col-3">
                      <p class="mx-5 fw-bold">Duration</p>
                      <vue-timepicker class="mx-5 mt-1  fw-bold" v-model="ThursdaydurationData" format="HH:mm:ss"></vue-timepicker>
                    </div>
                    <div class="col-2">
                      <b-btn class="mt-4 mr-3" type="button" variant="primary" @click="onResetCooldown('thursday')">Reset Cooldown</b-btn>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <p class="h4 mx-4 fw-bold">Friday</p>
                  <div class="d-flex">
                    <div class="col-3">
                      <p class="mx-4 ml-5 fw-bold">Next Winner On</p>
                      <input type="text" class="form-control mx-4" id="friday-cooldown-input" v-model="fridayCooldown" disabled />
                    </div>
                    <div class="col-2 mx-4">
                      <p class="mx-4 fw-bold">Winner(s) Limit</p>
                      <input type="text" class="form-control mx-4" id="friday-winners-input" placeholder="" v-model="fridayWinners" />
                    </div>
                    <div class="col-3">
                      <p class="mx-5 fw-bold">Duration</p>
                      <vue-timepicker class="mx-5 mt-1  fw-bold" v-model="FridaydurationData" format="HH:mm:ss"></vue-timepicker>
                    </div>
                    <div class="col-2">
                      <b-btn class="mt-4 mr-3" type="button" variant="primary" @click="onResetCooldown('friday')">Reset Cooldown</b-btn>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <p class="h4 mx-4 fw-bold">Saturday</p>
                  <div class="d-flex">
                    <div class="col-3">
                      <p class="mx-4 ml-5 fw-bold">Next Winner On</p>
                      <input type="text" class="form-control mx-4" id="saturday-cooldown-input" v-model="saturdayCooldown" disabled />
                    </div>
                    <div class="col-2 mx-4">
                      <p class="mx-4 fw-bold">Winner(s) Limit</p>
                      <input type="text" class="form-control mx-4" id="saturday-winners-input" placeholder="" v-model="saturdayWinners" />
                    </div>
                    <div class="col-3">
                      <p class="mx-5 fw-bold">Duration</p>
                      <vue-timepicker class="mx-5 mt-1  fw-bold" v-model="SaturdaydurationData" format="HH:mm:ss"></vue-timepicker>
                    </div>
                    <div class="col-2">
                      <b-btn class="mt-4 mr-3" type="button" variant="primary" @click="onResetCooldown('saturday')">Reset Cooldown</b-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-modal>

      </ValidationObserver>
  </div>
</template>

<style>
  .form-label.item-percentage {
      color: #aaaaaa;
      font-size: 11px !important;
  }
  .input-append {
    border: 1px solid #e2e5e8;
    border-right: none;
    padding: 4px 0 2px 10px;
    font-size: 20px;
    color: #747474;
    background: #FFF;
  }
  .append-red-border {
    border-color: red;
  }
</style>